import { render, staticRenderFns } from "./kpiListTable.vue?vue&type=template&id=81258ff4&"
import script from "./kpiListTable.vue?vue&type=script&lang=js&"
export * from "./kpiListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports